import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestsTestIds } from '../../../testids/RestrictionRuleRequestsTestIds'

export const restrictionRuleRequestsHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [RestrictionRuleRequestsTestIds.restrictionRuleRequestsList]:
      'Governance proposals for restriction rule lifecycle changes — creating, updating, deleting, activating, and deactivating all require approval.',
    [RestrictionRuleRequestsTestIds.btnCreateRequest]: 'Submit a new restriction rule request — to propose a new rule or change an existing one.',
    [RestrictionRuleRequestsTestIds.colLinkedRule]: 'Restriction rule this request affects — empty for create requests.',
    [RestrictionRuleRequestsTestIds.colRequestType]: 'Type of change proposed — create, update, delete, activate, or deactivate.',
    [RestrictionRuleRequestsTestIds.linkRequestName]: 'Open the request to review proposed changes, comments, and approval status.',
  },
}
